import React from "react";
import moment from "moment";
import {Table} from "antd";
import { HelperAttendance } from "types/helper-attendance";

export const InvoiceExpandedTable = (record: {
  helperAttendances: HelperAttendance[];
}) => {
  const nestColumns = [
    {
      title: "job number",
      dataIndex: ["taskRecord", "task", "taskNo"],
      key: "taskNo",
    },
    {
      title: "title",
      dataIndex: ["taskRecord", "task", "title"],
      key: "title",
    },
    {
      title: "helper",
      dataIndex: ["taskAttendance", "helper"],
      key: "helper",
      render: (text: string, record: HelperAttendance) => (`${record?.helper?.nameCn || record?.helper?.nameEn} (${record?.helper?.phone})`)
    },
    {
      title: "working date",
      dataIndex: ["taskRecord", "startDate"],
      key: "startDate",
    },
    {
      title: "working hours",
      dataIndex: "",
      key: "startTime",
      render: (text: string, workRecord: HelperAttendance) => {
        return (
          <>
            {moment(workRecord?.taskRecord?.startTime, "HH:mm:ss").format(
              "HH:mm"
            )}{" "}
            -{" "}
            {moment(workRecord.taskRecord.startTime, "HH:mm:ss")
              .add(workRecord.taskRecord.workingHours, "hour")
              .format("HH:mm")}{" "}
            ({workRecord.taskRecord.workingHours}小時)
          </>
        );
      },
    },
    {
      title: "employer price",
      dataIndex: "employerPrice",
      key: "employerPrice",
      render: (text: string) => `$${text}`,
    },
  ];

  return (
    <Table
      columns={nestColumns}
      dataSource={record.helperAttendances}
      pagination={false}
    />
  );
};
